import React from 'react';
import {
  Button,
  DetailBox,
  DropdownSelector,
  FormError,
  SelectionSet,
  SlideDown,
  useErrorScroll,
  useForm,
} from 'library';
import { getAllStatesForDropdown } from 'utils/states';

import './QuizBasicForm.scss';

const QuizBasicForm = ({ onSubmit }) => {
  const { handleSubmit, registerField, formData, formSubmitError } = useForm();
  useErrorScroll(formSubmitError);

  const states = getAllStatesForDropdown();
  const handleFormatOnSubmit = (data) => {
    if (data.homeowner_status === 'no') {
      data.is_homeowner = false;
    }
    onSubmit(data);
  };

  return (
    <div className="QuizBasicForm">
      <FormError standalone error={formSubmitError} />
      <h2>Let's start with the basics:</h2>
      <form onSubmit={handleSubmit(handleFormatOnSubmit)}>
        <SelectionSet
          label="Are you a homeowner?"
          options={[
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' },
            { label: 'I own multiple homes', value: 'multiple' },
          ]}
          required
          {...registerField('homeowner_status')}
        />
        <SlideDown visible={formData.homeowner_status === 'multiple'}>
          <DetailBox
            icon="icon-house"
            emphasis="Note:"
            text="Hometap currently invests in primary residences, vacation homes, and rental properties. We invest in single and multi-family homes, as well as condos."
          />
        </SlideDown>

        <DropdownSelector
          label="What state is your property located in?"
          options={states}
          required
          {...registerField('state')}
        />

        <Button type="submit">Continue</Button>
      </form>
    </div>
  );
};

export default QuizBasicForm;
